import React, { useState } from 'react'
import { CheckOutlined, PlusOutlined } from '@ant-design/icons';

const iconStyle: React.CSSProperties = {
  color: '#FFF', 
  fontSize: window.innerWidth > 600 ? 20 : 16
}

function index(props: {text: string, onClick: (() => void) | undefined, disabled?: boolean | undefined, icon?: React.ReactElement, innerProps?: {id: string}}) {
  return (
    <div {...props.innerProps} className={`floating-button ${(props.disabled || !props.onClick) && 'floating-button--disabled'}`} onClick={() => props.onClick ? props.onClick() : {}}>
      <FloatingButtonIcon icon={props.icon} text={props.text}/>
      <div className="floating-button__text">
        {props.text}
      </div>
    </div>
  )
}

const FloatingButtonIcon = (props: {icon?: React.ReactElement, text: string}) => {
  const buttonText = props.text.toUpperCase()
  const isSaveButton = buttonText.includes('SAVE')
  const isAddButton = buttonText.includes('ADD')
  if(props.icon) return props.icon
  if(isSaveButton) return <CheckOutlined style={iconStyle}/>
  if(isAddButton) return <PlusOutlined style={iconStyle} />
  return null
}
export default index